import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryProjects } from '@wix/ambassador-portfolio-projects-v1-project/http';
export const fetchPortfolioProjects = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  const chunkProjects = [];
  await withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    for (const idChunk of idChunks) {
      const {
        data: {
          projects
        }
      } = await httpClient.request(queryProjects({
        query: {
          filter: idChunk.length > 0 ? {
            id: {
              $in: idChunk
            }
          } : undefined,
          paging: {
            limit: COMMON_PAGE_LIMIT,
            offset: 0
          }
        }
      }));
      chunkProjects.push(...(projects ?? []));
    }
  }, {
    errorCodesMap: {}
  });
  return chunkProjects;
};
//# sourceMappingURL=fetch-portfolio-projects.js.map